

























































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';
import { Cart } from '@/models/cart';
import u from '@/utility/utility';
@Component({})
export default class CartItem extends Vue {
    @Prop({default: null})
    private cart!: Cart;

    @Prop({default: 0})
    private index!: number;

    get shippingMethod() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].shippingMethod;
    }

    protected proxyImage(src: string): string {
        return u.proxyImage(src);
    }

    private async getShippingMethod() {
        const result = await commonService.getShippingMethod();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_SHIPPINGMETHOD', result.data.data);
        }
    }

    private async created() {
        if (!this.shippingMethod) {
            await this.getShippingMethod();
        }
    }
}
